<template>
  <q-dialog
    v-model="dialog"
    style="max-width: 500px"
    persistent
    class="custom-font text-uppercase"
  >
    <q-card class="full-width pragma-black text-white">
      <q-form @submit.prevent="rechazar()">
        <q-card-section class="q-pa-none text-white">
          <q-toolbar
            class="bg-pragma"
          >
            <span class="text-bold">Rechazar Solicitud</span>
            <q-space></q-space>
            <q-btn
              icon="clear"
              flat
              @click="closeDialog()"
            ></q-btn>
          </q-toolbar>
        </q-card-section>
        <q-card-section>
          <q-input
            v-model="motivo"
            type="textarea"
            label="Describa el motivo de rechazo"
            class="tu"
            autogrow
            dense
            outlined
            label-color="grey"
            dark
            :rules="[v => !!v || 'Requerido']"
          ></q-input>
        </q-card-section>
        <q-card-actions>
          <div class="row full-width">
            <div class="col-xs-6 q-pa-sm">
              <q-btn
                label="Cancelar"
                color="negative"
                icon="clear"
                class="full-width"
                @click="closeDialog()"
              ></q-btn>
            </div>
            <div class="col-xs-6 q-pa-sm">
              <q-btn
                type="submit"
                label="Rechazar"
                color="positive"
                icon="check"
                class="full-width"
                :loading="loading"
              ></q-btn>
            </div>
          </div>
        </q-card-actions>
      </q-form>
    </q-card>
  </q-dialog>
</template>

<script>
import {inject, ref} from 'vue'
import axios from 'axios'
import { useQuasar } from 'quasar'

export default {
  setup () {
    // Variables reactivas y no reactivas
    const bus = inject('bus')
    const $q = useQuasar()
    
    const dialog = ref(false)
    const motivo = ref('')
    const solicitud_id = ref(null)
    const loading = ref(false)

    // Métodos y funciones
    const rechazar = async () => {
      try {
        loading.value = true
        let platform
        if ($q.platform.is.platform === 'android') {
          platform = 'A'
        } else if ($q.platform.is.platform === 'iphone') {
          platform = 'I'
        } else {
          platform = 'W'
        }
        const data = {
          id_solicitud: solicitud_id.value,
          motivo: motivo.value,
          tipo: 'aprobador',
          platform
        }
        await axios.post('solicitud-rechazo', data)
        $q.notify({
          message: 'Solicitud rechazada',
          color: 'positive'
        })
        closeDialog()
        bus.emit('closeDialogEventoAutorizar')
      } catch (error) {
        loading.value = false
        return console.log(error)
      }
    }

    const closeDialog = () => {
      motivo.value = ''
      solicitud_id.value = null
      loading.value = false
      dialog.value = false
    }

    // Creación del componente
    bus.on('openDialogRechazarSolicitud', (item) => {
      solicitud_id.value = item
      dialog.value = true
    })

    // Retorno de variables al template
    return {
      dialog,
      rechazar,
      motivo,
      loading,
      closeDialog
    }
  }
}
</script>

<style>

</style>